import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'

import type { AuthStatus } from '@/shared/auth/auth-store'

export interface RouterContext {
  readonly auth: {
    readonly status: AuthStatus
    readonly roles: readonly string[]
  }
  /** Para os loaders pré-carregarem com ensureQueryData — sem waterfall. */
  readonly queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

function RootLayout() {
  return <Outlet />
}
